export interface Template {
  id: string;
  code: string;
  channel: string;
  name: string;
  subject: string | null;
  body: string;
  variables: string[];
  locale?: string | null;
  isActive: boolean;
}

export const CHANNEL_LABELS: Record<string, string> = {
  sms: 'SMS',
  email: 'Email',
  whatsapp: 'WhatsApp',
  push: 'Push',
};

export const TEMPLATES_QUERY_KEY = ['notification-templates'] as const;
